import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";
const API = `${BACKEND_URL}/api`;

/**
 * Phase B - live collection data client.
 * All marble types / lots / slabs are read from MongoDB via these endpoints
 * (see backend/server.py). Throws on 404/network errors - callers handle
 * loading/notFound/error states explicitly.
 */
export const fetchMarbleTypes = async () => {
  const res = await axios.get(`${API}/marble-types`);
  return res.data;
};

export const fetchMarbleTypeBySlug = async (slug) => {
  const res = await axios.get(`${API}/marble-types/${encodeURIComponent(slug)}`);
  return res.data;
};

export const fetchLotsByMarbleSno = async (marbleSno) => {
  const res = await axios.get(`${API}/lots`, { params: { marble_sno: marbleSno } });
  return res.data;
};

export const fetchLotBySno = async (lotSno) => {
  const res = await axios.get(`${API}/lots/${encodeURIComponent(lotSno)}`);
  return res.data;
};

export const fetchSlabsByLotSno = async (lotSno) => {
  const res = await axios.get(`${API}/slabs`, { params: { lot_sno: lotSno } });
  return res.data;
};
